// removed by extract-text-webpack-plugin
module.exports = {"Modal":"_2JZlTzBU-ECuUlx7vjwkig","ModalHeader":"_25qolLnZQnf2R83t69F0bG","ModalBody":"_1Wcj-fAoJRpgse48QIXKnP","ModalWrapper":"i8RrZ4GePQH1SqO4NSKCe"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/Modal/style.css
// module id = 2477
// module chunks = 0